import { useTranslation } from "react-i18next"

import {
  Box,
  TalentechSvgImages,
  Typography,
  useSvg,
} from "@talentech/components"

interface IPoweredByFooterProps {
  showTalentechLink?: boolean
}

const PoweredByFooter = (props: IPoweredByFooterProps) => {
  const { t } = useTranslation()

  const { showTalentechLink } = props

  return (
    <footer 
      className="flex-column align-items-center align-self-stretch gap-3 py-4 d-flex"
      data-cy="powered-by-footer"
    >
      <Box
        flex
        className="flex-column align-items-center align-self-stretch gap-3"
      >
        <Typography className="text-align-center fs-12 m-0 text-300">
          {t("Footer.PoweredBy.Text")}
        </Typography>

        <img
          src={useSvg(TalentechSvgImages.LOGOTALENTECH)}
          alt="Talentech logo"
          width="120"
          height="17"
        />
      </Box>

      {showTalentechLink && (
        <Typography className="mt-3 mb-0">
          <a
            href="https://www.talentech.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-300 text-decoration-underline border-0"
            data-cy="talentech-link"
          >
            {t("Footer.PoweredBy.LikeService")}
          </a>
        </Typography>
      )}
    </footer>
  )
}

export default PoweredByFooter
